function logError(error) {
	console.log(error);
	throw error;
}

export { logError };
